<template>
  <div name="PaymentGateway">
    <app-payForm-datacap ref="PayForm_DataCap"></app-payForm-datacap>
    <app-payForm-transaction-junction
      ref="PayForm_TransactionJunction"
    ></app-payForm-transaction-junction>
    <app-loaderForm :display="'none'" ref="LoaderForm"></app-loaderForm>
    <app-errorForm :show="false" ref="ErrorForm"></app-errorForm>
  </div>
</template>
<!-- Scripts -->
<script>
import { view } from './OnlinePayments.vue.js';
import PayFormDataCap from './PayForm_DataCap.vue';
import PayFormTransactionJunction from './PayForm_TransactionJunction.vue';
import LoaderForm from '../../components/LoaderForm.vue';
import ErrorForm from './ErrorForm.vue';

export default {
  name: 'OnlinePayments',
  components: {
    'app-payForm-datacap': PayFormDataCap,
    'app-payForm-transaction-junction': PayFormTransactionJunction,
    'app-loaderForm': LoaderForm,
    'app-errorForm': ErrorForm
  },
  mixins: [view],
  data() {
    return {
      JsScriptUrl: '',
      PaymentReference: '',
      MerchantKey: '',
      PaymentKey: '',
      CancelURL: '',
      PaymentType: ''
    };
  },
  mounted() {
    var _self = this;

    var data = {
      PaymentProvider: _self.getParameterByName('PaymentProvider'),
      FranchiseID: localStorage.franchiseID,
      BranchID: localStorage.branchID,
      PaymentReference: _self.getParameterByName('PaymentReference'),
      PaymentKey: _self.getParameterByName('PaymentKey')
    };
    _self.$ooApi.orders.payment.v1(data).then(function(result) {
      _self.JsScriptUrl = result.data.jsScriptUrl;
      _self.PaymentReference = result.data.paymentReference;
      _self.MerchantKey = result.data.merchantKey;
      _self.PaymentKey = result.data.paymentKey;
      _self.CancelURL = result.data.cancelURL;
      _self.PaymentType = result.data.paymentType;

      if (result.data.paymentType == 'DataCap') _self.showDataCap();
      else if (result.data.paymentType == 'TransactionJunction')
        _self.showTransactionJunction();
    });
  },
  methods: {
    showDataCap: function() {
      this.$refs.PayForm_DataCap.showForm(true);
    },
    showTransactionJunction: function() {
      this.$refs.PayForm_TransactionJunction.showForm(true);
      this.pollTransaction();
    },
    pollTransaction: function() {
      var _self = this;
      var completed = false;
      var startTime = new Date().getTime();
      var timeoutTime = new Date(startTime + 5 * 60000).getTime();
      var lastRunTime = startTime;
      var paymentReference = _self.getParameterByName('PaymentReference');

      var data = {
        FranchiseID: _self.$franchiseID,
        PaymentReference: paymentReference
      };
      function checkTransactionStatus() {
        if (_self.$route.name != 'OnlinePayments' || !paymentReference) return;
        _self.$ooApi.orders.payment.status.v1(data).then(function(result) {
          if (result.data.completed == true) {
            completed = true;

            document.querySelector('body').removeAttribute('style');
            document.querySelector('.banner-container').removeAttribute('style');
            document.querySelector('#eftsecure_checkout_app_wrapper').remove();

            _self.$router.push({
              path: result.data.status,
              query: { PaymentReference: _self.PaymentReference }
            });
          }
        });
      }

      function updateTimeoutTimer() {
        var currentTime = new Date().getTime();

        //Check Transaction Status every 5sec
        if (currentTime - lastRunTime > 5 * 1000) {
          checkTransactionStatus();
        }

        //Update timeout timer ui
        if (!completed) {
          if (timeoutTime > currentTime) {
            setTimeout(updateTimeoutTimer, 1000);
          } else {
            _self.$router.push({
              path: 'Cancel',
              query: {
                PaymentReference: _self.getParameterByName('PaymentReference')
              }
            });
          }
        }
      }

      updateTimeoutTimer();
    }
  }
};
</script>
<style scoped>
@import './OnlinePayments.vue.css';
</style>
